export default __webpack_public_path__ + "media/images/casatb/tenant/how-to-rent-one-c23faf7e5ea81caa25751634e5c1031f.png";